/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";

/**
 *
 * @export
 * @interface CompanyShipmentQuote
 */
export interface CompanyShipmentQuote {
  /**
   *
   * @type {Shipment}
   * @memberof CompanyShipmentQuote
   */
  shipment: Shipment;
  /**
   *
   * @type {Company}
   * @memberof CompanyShipmentQuote
   */
  company: Company;
  /**
   *
   * @type {Quote}
   * @memberof CompanyShipmentQuote
   */
  quote: Quote;
  /**
   *
   * @type {boolean}
   * @memberof CompanyShipmentQuote
   */
  hasScannedBol?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CompanyShipmentQuote
   */
  hasProofOfDelivery?: boolean | null;
}

/**
 * Check if a given object implements the CompanyShipmentQuote interface.
 */
export function instanceOfCompanyShipmentQuote(
  value: object,
): value is CompanyShipmentQuote {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("quote" in value) || value["quote"] === undefined) return false;
  return true;
}

export function CompanyShipmentQuoteFromJSON(json: any): CompanyShipmentQuote {
  return CompanyShipmentQuoteFromJSONTyped(json, false);
}

export function CompanyShipmentQuoteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyShipmentQuote {
  if (json == null) {
    return json;
  }
  return {
    shipment: ShipmentFromJSON(json["shipment"]),
    company: CompanyFromJSON(json["company"]),
    quote: QuoteFromJSON(json["quote"]),
    hasScannedBol:
      json["hasScannedBol"] == null ? undefined : json["hasScannedBol"],
    hasProofOfDelivery:
      json["hasProofOfDelivery"] == null
        ? undefined
        : json["hasProofOfDelivery"],
  };
}

export function CompanyShipmentQuoteToJSON(json: any): CompanyShipmentQuote {
  return CompanyShipmentQuoteToJSONTyped(json, false);
}

export function CompanyShipmentQuoteToJSONTyped(
  value?: CompanyShipmentQuote | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipment: ShipmentToJSON(value["shipment"]),
    company: CompanyToJSON(value["company"]),
    quote: QuoteToJSON(value["quote"]),
    hasScannedBol: value["hasScannedBol"],
    hasProofOfDelivery: value["hasProofOfDelivery"],
  };
}
